import axios from "axios";
import { useEffect, useState } from "react";
import { API_ENDPOINT, HEADER_TOKEN } from "../../constants/constants";
import "./assessment.css";
import gl from "../../assets/gifs/loading.gif";
import IntroHeader from "../widgets/introHeader";
import { getCandidateName, saveCandidateName,isCandidateExists } from "../../utilities/utility";
const WaitingForTrainer = ({
  setStarted,
  linkCode,
  socket,
  ainfo,
  setAinfo,
  onGoLive,
}) => {
  const WAITING = "waiting";

  useEffect(() => {
    if (socket !== null) {
      socket.on("start-" + linkCode, (m) => {
        console.log("Socket works");
        onGoLive();
      });
    }
  }, [socket]);
  // Function to check the status
  async function checkStatus() {
    try {
      axios
        .post(
          API_ENDPOINT + "assessment-details/",
          { linkCode },
          HEADER_TOKEN
        )
        .then((res) => {
          let d = res.data;
          if (d.success) {
            let A = d.message;
            if (A.status === "started") {
              onGoLive();
            }
          }
        });
    } catch (error) {
      console.error("Error fetching status:", error);
    }
  }
  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 120000)
}); // 60 seconds
  // Poll the status every 5 seconds
  //setInterval(checkStatus, 10000);
  const [name, setName] = useState();
  useEffect(() => {
    setName(getCandidateName()?.name || "");
  }, []);
  useEffect(()=>{
      if(isCandidateExists()){
          let cn = getCandidateName()
           let d = {name: cn.name, status: WAITING, score: 0, linkCode: ainfo.linkCode, numAttempted: 0}
           socket.emit("joining", d)

           socket.on('start-'+linkCode, m=>{
              /*
                  START ASSESSMENT COMMAND
              */
             //document.location.href = '/assessment/live/'+linkCode
             onGoLive()
           })
      }
  }, [])

  return (
    <>
      
      {/* assessment */}
        <div className="assessment-box-2">
        {/* assessment end */}
             {/* gif */}
             <IntroHeader ainfo={ainfo} />
             <div className="assessment-content align-items-center">
                <img src={gl} alt="Loading GIF" className="gif-section mb-3" />
                <p className="text-start fw-bold mb-0">Thank you for your patience. Your assessment will begin shortly!</p>
            </div>
        </div>
    </>
  );
};
export default WaitingForTrainer;
